import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsQueryPatternExisted implements ICommand
{


	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();


		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsQueryPatternExisted();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		return str;
	}

	public getCmdID() : number
	{
		return 55068;
	}

	public getCmdName() : string
	{
		return 'PsQueryPatternExisted';
	}

}
